import React, { useState } from 'react';
import axios from 'axios';
import './Auth.css';

const API_URL = "https://shopify-ingestion-production.up.railway.app/api";

function Signup({ onSignupSuccess, onSwitchToLogin }) {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
    storeName: '',
    storeUrl: '',
    accessToken: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (formData.password !== formData.confirmPassword) {
      alert('❌ Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      alert('❌ Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/auth/signup`, {
        fullName: formData.fullName,
        email: formData.email,
        password: formData.password,
        storeName: formData.storeName,
        storeUrl: formData.storeUrl,
        accessToken: formData.accessToken
      });

      if (response.data.success) {
        alert('✅ Account created! Please login.');
        onSignupSuccess();
      } else {
        alert('❌ ' + response.data.message);
      }
    } catch (error) {
      console.error(error);
      alert('❌ Signup failed. Check console.');
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-box signup-box">
        <div className="auth-header">
          <h1>🚀 Create Account</h1>
          <p>Start analyzing your Shopify store</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="input-group">
            <label>Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="John Doe"
              value={formData.fullName}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>

          <div className="input-group">
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="you@example.com"
              value={formData.email}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>

          <div className="input-row">
            <div className="input-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                placeholder="Min 6 characters"
                value={formData.password}
                onChange={handleChange}
                className="input-field"
                required
              />
            </div>

            <div className="input-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Re-enter password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="input-field"
                required
              />
            </div>
          </div>

          <hr className="divider" />
          <p className="section-title">🛍️ Shopify Store Details</p>

          <div className="input-group">
            <label>Store Name</label>
            <input
              type="text"
              name="storeName"
              placeholder="My Awesome Store"
              value={formData.storeName}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>

          <div className="input-group">
            <label>Store URL</label>
            <input
              type="text"
              name="storeUrl"
              placeholder="your-store.myshopify.com"
              value={formData.storeUrl}
              onChange={handleChange}
              className="input-field"
              required
            />
          </div>

          <div className="input-group">
            <label>Admin API Access Token</label>
            <input
              type="text"
              name="accessToken"
              placeholder="shpat_xxxxxxxxxxxxx"
              value={formData.accessToken}
              onChange={handleChange}
              className="input-field"
              required
            />
            <small className="help-text">
              Get this from Shopify Admin → Apps → Develop apps
            </small>
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? '⏳ Creating Account...' : '✨ Create Account'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Already have an account?</p>
          <button onClick={onSwitchToLogin} className="switch-btn">
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}

export default Signup;